import 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PackingSlipPopupModalState {
  openPackingSlipPopupModal: boolean;
  loading: boolean;
}

const initialState: PackingSlipPopupModalState = {
  openPackingSlipPopupModal: false,
  loading: false,
};

export const packingSlipPopupModalSlice = createSlice({
  name: 'packingSlipPopupModal',
  initialState,
  reducers: {
    openPackingSlipPopupModal: (state) => ({
      ...state,
      openPackingSlipPopupModal: true,
    }),
    closeModal: () => ({
      ...initialState,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
  },
});

export const { openPackingSlipPopupModal, closeModal, setLoading } =
  packingSlipPopupModalSlice.actions;
export default packingSlipPopupModalSlice.reducer;
